export const formatRows = (listaItems) => 
    listaItems.map((item) => ({
      id: item.id,
      sel_firstname: item.sel_firstname|| "Nombre no disponibe",
      sel_lastname: item.sel_lastname|| "Apellido no disponibe",
      descripcionRol: item['empl-rol'].nombre|| "Rol no disponibe",
    }));
  